// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","leftSection":"Header_leftSection__g9hFJ","rightSection":"Header_rightSection__nlAZ6"};